import { Bar, Icon, TypeBadge } from '@/components';
import { useLocalized } from '@/hooks/useLocalized';
import type { Course, Enrollment } from '@/types/domain';

const STRIPE =
  'repeating-linear-gradient(135deg, rgba(255,255,255,.18), rgba(255,255,255,.18) 1px, transparent 1px, transparent 10px)';

/** Catalog course card — used in both mobile lists and desktop grids. */
export function CourseCard({
  course,
  enrollment,
  onClick,
}: {
  course: Course;
  enrollment?: Enrollment;
  onClick: () => void;
}) {
  const { L } = useLocalized();
  return (
    <button onClick={onClick} style={{ all: 'unset', cursor: 'pointer', display: 'block', height: '100%' }}>
      <div className="card lift" style={{ overflow: 'hidden', height: '100%' }}>
        {course.coverUrl ? (
          // Full cover, edge-to-edge at its natural ratio — no crop, no letterbox.
          <div style={{ position: 'relative' }}>
            <img src={course.coverUrl} alt={course.title.en} style={{ display: 'block', width: '100%', height: 'auto' }} />
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, display: 'flex', justifyContent: 'space-between', padding: 12 }}>
              <TypeBadge type={course.type} />
              <span className="u-mono" style={{ fontSize: 11, color: 'var(--ink-2)', background: 'rgba(251,250,247,.85)', padding: '3px 7px', borderRadius: 6 }}>{course.code}</span>
            </div>
          </div>
        ) : (
          <div style={{ aspectRatio: '3 / 1', background: course.cover, position: 'relative' }}>
            <div style={{ position: 'absolute', inset: 0, background: STRIPE }} />
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', padding: 12 }}>
              <TypeBadge type={course.type} />
              <span className="u-mono" style={{ fontSize: 11, color: 'var(--ink-2)', background: 'rgba(251,250,247,.85)', padding: '3px 7px', borderRadius: 6 }}>{course.code}</span>
            </div>
          </div>
        )}
        <div style={{ padding: '14px 16px 16px' }}>
          <div className="th" style={{ fontSize: 15.5, fontWeight: 600, lineHeight: 1.3 }}>{L(course.title)}</div>
          <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 2 }}>{course.title.en}</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 14, fontSize: 12.5, color: 'var(--ink-3)' }}>
            <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <Icon name="clock" size={14} /> {course.hours}h
            </span>
            {enrollment ? (
              <span className="u-mono" style={{ color: 'var(--sage-deep)', fontWeight: 600 }}>{enrollment.progress}%</span>
            ) : (
              <span style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                <Icon name="users" size={13} /> {course.enrolled}/{course.capacity}
              </span>
            )}
          </div>
          {enrollment && <Bar value={enrollment.progress} style={{ marginTop: 10 }} />}
        </div>
      </div>
    </button>
  );
}
